import { StateVisitEnum } from 'src/app/enum/state-visit.enum';

export class VisitModel {
  visitId: number = 0;
  state: number = StateVisitEnum.Pending;
  consecutive: number = 0;
  dateScheduled: Date | string | null = null;
  dateExecuted: Date | string | null = null;
  clientVisit: string = '';
  branchId: number = 0;
  branch: any = null;
  constructionSiteVisit: string = '';
  clientId: number | null = null;
  costCenterId: number | null = null;
  constructionSiteAddress: string = '';
  zoneId: number = 0;
  sellerId: number = 0;
  contact: string = '';
  position: string | null = null;
  phone1: string | null = null;
  phone2: string | null = null;
  swNewConstructionSite: boolean = false;
  initialGoal: string | null = null;
  result: string | null = null;
  swQuote: boolean = false;
  swBlock: boolean = false;
  email: string | null = null;
  conceptId: number | null = null;
  observationCancel: string | null = null;
  createDate: string = '';
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  constructor(data?: Partial<VisitModel>) {
    if (data) Object.assign(this, data);
  }
}
